import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class MyDialogService {

  constructor(
    private translateService: TranslateService
  ) { }

  public warningTitle(text: string, title: string = '', callback?: () => void) {
    Swal.fire({
      icon: 'warning',
      title: 'Warning',
      text,
      allowOutsideClick: false
    }).then(result => {
      if (callback !== undefined) { callback(); }
    });
  }
  public confirmSubmitData(callback: () => void) {
    const confirmText = this.translateService.instant('CONFIRM.SUBMIT_DATA');
    this.confirm('', confirmText, callback);
  }
  public confirmSaveData(callback: () => void) {
    const confirmText = this.translateService.instant('CONFIRM.SAVE_DATA');
    this.confirm('', confirmText, callback);
  }
  public confirmDeleteData(callback: () => void) {
    const confirmText = this.translateService.instant('CONFIRM.DELETE_DATA');
    this.confirm(null!, confirmText, callback);
  }
  public confirmTerms(callback: () => void) {
    const confirmText = this.translateService.instant('CONFIRM.TERMS');
    this.confirm('', confirmText, callback);
  }
  public confirmIndictment(callback: () => void) {
    const confirmText = this.translateService.instant('CONFIRM.INDICTMENT_DATA');
    this.confirm('', confirmText, callback);
  }
  public confirm(title: string, text: string, acceptCallback: () => void) {
    const confirmButtonText = this.translateService.instant('BUTTON.AGREE');
    const cancelButtonText = this.translateService.instant('BUTTON.CANCEL');
    Swal.fire({
      title,
      text,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#d33',
      confirmButtonText,
      cancelButtonText
    }).then((result) => {
      if (result.value) {
        acceptCallback();
      }
    });
  }

  public successIndictment(callback?: () => void) {
    const text = this.translateService.instant('ACTION.RESULT_INDICTMENT_COMPLETED');
    this.success(text, callback);
  }
  public successProceed(callback?: () => void) {
    const text = this.translateService.instant('ACTION.RESULT_PROCESS_COMPLETED');
    this.success(text, callback);
  }
  public successSendMail(callback?: () => void) {
    const text = this.translateService.instant('ACTION.RESULT_SEND_MAIL_COMPLETED');
    this.success(text, callback);
  }
  public successSubmited(callback?: () => void) {
    const text = this.translateService.instant('ACTION.RESULT_PROCESS_COMPLETED');
    this.success(text, callback);
  }
  public error(text: string, title: string = '', callback?: () => void) {
    Swal.fire({
      icon: 'error',
      title: 'Error!',
      text,
      allowOutsideClick: false
    }).then(result => {
      if (callback !== undefined) { callback(); }
    });
  }

  public errorNoTitle(text: string, callback?: () => void) {
    Swal.fire({
      icon: 'error',
      text,
      allowOutsideClick: false
    }).then(result => {
      if (callback !== undefined) { callback(); }
    });
  }
  public success(text: string, callback?: () => void) {
    Swal.fire({
      icon: 'success',
      title: text,
      showConfirmButton: false,
      timer: 1500,
      allowOutsideClick: false
    }).then(result => {
      if (callback !== undefined) { callback(); }
    });
  }

  public successTitle(text: string, title: string = '', callback?: () => void) {
    Swal.fire({
      icon: 'success',
      title: title,
      text,
      allowOutsideClick: false
    }).then(result => {
      if (callback !== undefined) { callback(); }
    });
  }

  public warningValidate(callback?: () => void) {
    const title = this.translateService.instant('ACTION.TITLE_VALIDATE_FAIL');
    const text = this.translateService.instant('ACTION.VALIDATE_FAIL');
    this.warning(title, text, callback);
  }

  public warningValidateText(textSwap: string, callback?: () => void) {
    const title = this.translateService.instant('ACTION.TITLE_VALIDATE_FAIL');
    const text = this.translateService.instant(textSwap);
    this.warning(title, text, callback);
  }

  public warning(title: string, text: string, callback?: () => void, html?: string) {
    const confirmButtonText = this.translateService.instant('BUTTON.AGREE');
    Swal.fire({
      icon: 'warning',
      title,
      text,
      html,
      showConfirmButton: true,
      //timer: 1500,
      allowOutsideClick: false,
      confirmButtonText
    }).then(result => {
      if (callback !== undefined) { callback(); }
    });
  }


  public confirmHtml(title: string, text: string, acceptCallback: () => void, html?: string) {
    const confirmButtonText = this.translateService.instant('BUTTON.AGREE');
    const cancelButtonText = this.translateService.instant('BUTTON.CANCEL');
    Swal.fire({
      title,
      text,
      html,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#d33',
      confirmButtonText,
      cancelButtonText
    }).then((result) => {
      if (result.value) {
        acceptCallback();
      }
    });
  }

public HtmlAlertCIdSecIdSuitId(chk01?:number,fdtName?:string,courtName?:string,blackNo?:string,redNo?:string,suitAccuser?:string,suitAccused?:string) :string{
  var strRe ='<br/><div class="card" style="background-color:#FFFFFF;color:#000000;margin-top: 1%;"><div class="card-body">'
  strRe = strRe + '<p class="fw-bold" style="color:#000000;margin-bottom: 0px;">'
  strRe = strRe + this.translateService.instant('FDTNAME_ALERT_PRE')  + fdtName
  strRe = strRe + '</p>'

  strRe = strRe + '<p class="fw-bold" style="color:#000000;margin-bottom: 0px;">'
  strRe = strRe + this.translateService.instant('FDTNAME_ALERT_END')  + ' ? '
  strRe = strRe + '</p>'

  if(chk01 = 1){
    strRe = strRe + '<p class="fw-bold" style="color:#000000;margin-bottom: 0px;">'
    strRe = strRe + this.translateService.instant('COLLECT_DES')
    strRe = strRe + '</p>'
   }

   strRe = strRe + '<p class="fs-5 fw-bold badge " style="background-color:#0D1546;color:#FFFFFF;margin-bottom: 0px;">'
   strRe = strRe +  '<i class="fas fa-university"></i>' + ' ' + courtName 
   strRe = strRe + '</p>'

   strRe = strRe + '<p class="fw-bold" style="color:#000000;margin-bottom: 0px;">'
   strRe = strRe +  blackNo 
   strRe = strRe + '</p>'

   if (redNo?.length != 0){
    strRe = strRe + '<p class="fw-bold" style="color:#000000;margin-bottom: 0px;">'
    strRe = strRe + '<span class="text-danger">' + redNo  + '<span>'
    strRe = strRe + '</p>'
   }
   else{
    strRe = strRe + '<p class="fw-bold" style="color:#000000;margin-bottom: 0px;">'
    strRe = strRe + '<span class="text-danger">คดีหมายเลขแดงที่ -<span>'
    strRe = strRe + '</p>'
   }


   strRe = strRe + '<p class="text-center fw-bold" style="color:#000000;margin-bottom: 0px;">'
   strRe = strRe +  this.translateService.instant('AS_PLAINTIFFHINSELF') 
   strRe = strRe + '</p>'

   strRe = strRe + '<p class="text-center fw-bold" style="color:#000000;margin-bottom: 0px;">'
   strRe = strRe +   ' ' +  suitAccuser 
   strRe = strRe + '</p>'

   strRe = strRe + '<p class="text-center fw-bold" style="color:#000000;margin-bottom: 0px;">'
   strRe = strRe +  this.translateService.instant('AS_DEFENDANTHIMSELF') 
   strRe = strRe + '</p>'

   strRe = strRe + '<p class="text-center fw-bold" style="color:#000000;margin-bottom: 0px;">'
   strRe = strRe + ' ' + suitAccused 
   strRe = strRe + '</p>'

   strRe = strRe + '</div>'
   strRe = strRe + '</div>'

   return strRe

}


}
